import emptyIcon from "../plugins/defaultImg";
export default {
  name: 'WeSpRight',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    theadData: {
      type: Object,
      default: function () {
        return {
          name: '姓名',
          id: '工号',
          dept: '组织机构'
        };
      }
    }
  },

  data() {
    return {
      emptyIcon: emptyIcon.imgBase64
    };
  },

  computed: {
    selected() {
      const {
        value
      } = this;
      return value;
    }

  },
  methods: {
    selectAllOrClear() {
      this.$emit('on-selectall');
    },

    setTop() {
      this.$emit('on-set-top');
    },

    setBottom() {
      this.$emit('on-set-bottom');
    },

    moveUp() {
      this.$emit('on-move-up');
    },

    moveDown() {
      this.$emit('on-move-down');
    },

    handlerClearAllSelect() {
      this.$emit("on-clear");
    },

    deleteRecords() {
      this.$emit('on-delete');
    },

    deleteRecords_in(user) {
      this.$emit('on-delete', user);
    },

    checkItem(user) {
      this.$emit('on-check-item', user);
    }

  }
};